import { render, staticRenderFns } from "./spotify.vue?vue&type=template&id=566d3223&"
import script from "./spotify.vue?vue&type=script&lang=js&"
export * from "./spotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports